import { render, staticRenderFns } from "./GlobalSetting.vue?vue&type=template&id=c28cd04a"
import script from "./GlobalSetting.vue?vue&type=script&lang=js"
export * from "./GlobalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports